export default "__VITE_ASSET__CwvGEjBT__"